"use client";

import React, { useEffect, useState } from "react";
import { Phone, MapPin, Radio } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function EmergencyRoadsideDispatch() {
  const [activeLocation, setActiveLocation] = useState("Norwich");
  const locations = ["Norwich", "King's Lynn", "Thetford", "Great Yarmouth", "Lowestoft", "Cromer", "Fakenham", "Dereham", "Swaffham", "Wymondham"];
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveLocation(prev => {
        const currentIndex = locations.indexOf(prev);
        const nextIndex = (currentIndex + 1) % locations.length;
        return locations[nextIndex];
      });
    }, 3000);
    return () => clearInterval(interval);
  }, []);
  return <section id="emergency-roadside-dispatch" className="dark bg-background text-foreground relative w-full overflow-hidden py-24 md:py-32 border-y border-border/10">
      {}
      <style jsx global>{`
        @keyframes radar-spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        @keyframes vibrate-intermittent {
          0%, 90%, 100% { transform: translate(0, 0); }
          91% { transform: translate(-2px, 2px); }
          92% { transform: translate(2px, -2px); }
          93% { transform: translate(-2px, -2px); }
          94% { transform: translate(2px, 2px); }
          95% { transform: translate(-2px, 2px); }
          96% { transform: translate(2px, -2px); }
          97% { transform: translate(-2px, -2px); }
          98% { transform: translate(2px, 2px); }
          99% { transform: translate(-1px, -1px); }
        }
        .animate-radar {
          animation: radar-spin 4s linear infinite;
        }
        .animate-vibrate {
          animation: vibrate-intermittent 5s ease-in-out infinite;
        }
      `}</style>

      {}
      <div className="absolute inset-0 flex items-center justify-center overflow-hidden pointer-events-none opacity-20">
        {}
        <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.05)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.05)_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_at_center,black_40%,transparent_80%)]" />
        
        {}
        <div className="relative w-[150vw] h-[150vw] md:w-[80vw] md:h-[80vw] max-w-[1000px] max-h-[1000px]">
          <div className="absolute inset-0 rounded-full border border-primary/20" />
          <div className="absolute inset-[15%] rounded-full border border-primary/10" />
          <div className="absolute inset-[30%] rounded-full border border-primary/5" />
          <div className="absolute inset-[-50%] w-[200%] h-[200%] top-[-50%] left-[-50%] animate-radar bg-[conic-gradient(from_0deg_at_50%_50%,transparent_0deg,transparent_300deg,var(--color-primary)_360deg)] opacity-30 [mask-image:radial-gradient(circle_at_center,black_0%,transparent_60%)]" />
        </div>
      </div>

      {}
      <div className="relative z-10 container mx-auto px-4 flex flex-col items-center text-center">
        
        {}
        <div className="mb-8 space-y-4">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-destructive/10 border border-destructive/20 text-destructive text-sm font-bold uppercase tracking-wider animate-pulse">
            <Radio className="w-4 h-4" />
            Emergency Response Active
          </div>
          
          <h2 className="text-4xl md:text-6xl lg:text-7xl font-black tracking-tighter uppercase">
            <span className="bg-gradient-to-r from-red-500 via-orange-500 to-yellow-500 bg-clip-text text-transparent drop-shadow-sm">
              Locked Out Right Now?
            </span>
          </h2>
          
          <p className="text-muted-foreground text-lg md:text-xl max-w-2xl mx-auto font-medium">
            Our dispatch team is on standby. Priority routing for roadside emergencies.
          </p>
        </div>

        {}
        <div className="relative group">
          <div className="absolute -inset-1 bg-gradient-to-r from-red-500 to-yellow-500 rounded-xl blur opacity-25 group-hover:opacity-50 transition duration-1000 group-hover:duration-200 animate-pulse" />
          <Button asChild size="lg" className="relative animate-vibrate h-auto py-6 px-12 text-2xl md:text-3xl font-black uppercase tracking-widest bg-destructive hover:bg-destructive/90 text-white border-b-4 border-red-900 active:border-b-0 active:translate-y-1 transition-all shadow-[0_0_40px_-10px_rgba(239,68,68,0.6)]">
            <Link to="tel:07700123456">
              <Phone className="w-8 h-8 md:w-10 md:h-10 mr-4 fill-current" />
              Call Dispatch
            </Link>
          </Button>
        </div>

        {}
        <div className="mt-12 w-full max-w-md mx-auto">
          <div className="bg-card/50 backdrop-blur-sm border border-border/50 rounded-lg p-4 flex items-center justify-center gap-3 shadow-lg">
            <div className="relative flex h-3 w-3">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-3 w-3 bg-green-500"></span>
            </div>
            <div className="text-sm md:text-base font-mono text-foreground/90">
              <span className="text-muted-foreground">Active Technician in:</span>
              <span className="ml-2 font-bold text-primary inline-block min-w-[120px] text-left">
                {activeLocation}
              </span>
            </div>
          </div>
          <p className="text-xs text-muted-foreground mt-2 font-mono">
            Average response time: &lt; 30 mins
          </p>
        </div>

      </div>
    </section>;
}